import { createFileRoute, redirect } from '@tanstack/react-router';
import { fetchSession, sessionQueryKey } from '@/lib/auth';
import { currentBrand } from '@/lib/brand';
import { landingPath, visibleWorlds } from '@/components/shell/nav';

// `/` is where someone lands: the first module of their only world, or the
// dashboard when they see more than one (components/shell/nav.ts). On the names
// of Alfen there is only the portal.
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    if (currentBrand() === 'alfen') throw redirect({ to: '/portal' });
    const session = await context.queryClient.ensureQueryData({
      queryKey: sessionQueryKey,
      queryFn: fetchSession,
    });
    if (!session) throw redirect({ to: '/login' });
    throw redirect({ to: landingPath(visibleWorlds(session)) });
  },
});
